module.exports = __webpack_public_path__ + "static/img/3.75f8d0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/3.jpg
// module id = +j7M
// module chunks = 1